<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL"
  )
  app-modal-cancelar-retificacao(
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="closeRetificacao"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    AppModalCancelarRetificacao
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_PORTARIA_VALIDACAO'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      numeroProcesso: null,
      protocolo: null,
      showModalRetificacao: false,
      idProcesso: null,
      tipoProcesso: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_PORTARIA_VALIDACAO || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_PORTARIA_VALIDACAO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroSituacao') },
        { id: 4, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroResponsavel') },
        { id: 7, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 9, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 3, nome: 'Validar Portaria', icone: 'fa-check', codigo: 'VALIDAR_PORTARIA', ordem: 1, show: this.showValidarPortaria, showToltip: this.showToltipRetificacao, textToltip: this.textToltip },
            { id: 4, nome: 'Cancelar Retificação', icone: 'fa-times', codigo: 'CANCELAR_RETIFICACAO', ordem: 1, show: this.showCancelarRetificacaoProcessso }
          ]
        }
      ],
      usuario: null,
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario.perfilSelecionado.codigo) !== undefined
    },
    VALIDAR_PORTARIA (_this, { item }) {
      _this.$router.push({
        name: 'portariaValidar',
        params: {
          idProcesso: item.id,
          protocolo: item.numeroProtocolo
        }
      })
    },

    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    TROCAR_RESPONSAVEL: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },

    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    CANCELAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    closeRetificacao (item) {
      this.showModalRetificacao = false
      this.refresh()
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaValidacaoPortaria.vue